export default __webpack_public_path__ + "static/media/img_3.c6d4d0ef.svg";